import { BidStatus, type PortalMyBidDto } from "../../../autogen/bff-api";

export const ownPortalBid = (bids: readonly PortalMyBidDto[] | undefined, eventId: string): PortalMyBidDto | undefined => {
  const forEvent = (bids ?? []).filter((bid) => bid.eventId === eventId);
  return forEvent.find((bid) => bid.status === BidStatus.Rejected) ?? forEvent[0];
};

export const isRejectedInEvent = (
  bids: readonly PortalMyBidDto[] | undefined,
  eventId: string,
  exceptBidId?: string,
): boolean =>
  (bids ?? []).some((bid) => bid.eventId === eventId && bid.status === BidStatus.Rejected && bid.bidId !== exceptBidId);
